import { useState } from 'react';

const useTurniModals = () => {
  const [isDayModalOpen, setIsDayModalOpen] = useState(false);
  const [isTurnoModalOpen, setIsTurnoModalOpen] = useState(false);
  const [isFerieModalOpen, setIsFerieModalOpen] = useState(false);
  const [isManagerFerieOpen, setIsManagerFerieOpen] = useState(false);
  const [isOrarioFissoOpen, setIsOrarioFissoOpen] = useState(false);
  const [isReperibilitaModalOpen, setIsReperibilitaModalOpen] = useState(false);
  const [showRanges, setShowRanges] = useState(false);
  const [showOnlyUncovered, setShowOnlyUncovered] = useState(false);
  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedWeek, setSelectedWeek] = useState(0);
  const [viewMode, setViewMode] = useState('mensile');

  const handleDayClick = (day) => { setSelectedDay(day); setIsDayModalOpen(true); };

  return {
    isDayModalOpen, setIsDayModalOpen,
    isTurnoModalOpen, setIsTurnoModalOpen,
    isFerieModalOpen, setIsFerieModalOpen,
    isManagerFerieOpen, setIsManagerFerieOpen,
    isOrarioFissoOpen, setIsOrarioFissoOpen,
    isReperibilitaModalOpen, setIsReperibilitaModalOpen,
    showRanges, setShowRanges,
    showOnlyUncovered, setShowOnlyUncovered,
    selectedDay, selectedWeek, setSelectedWeek,
    viewMode, setViewMode, handleDayClick,
  };
};

export default useTurniModals;
